import { Chip, Css, MultiSelectField } from "@homebound/beam";
import { showPBBv2Personalization } from "src/features";
import { PotentialBidPlanDimensionKind } from "src/generated/graphqlTypes";
import { ConfigureBidGroupsStep_PotentialBidPlanDimensionResultFragment } from "src/routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";

type PersonalizationGroupsFieldProps = {
  dimensionResults: ConfigureBidGroupsStep_PotentialBidPlanDimensionResultFragment[];
  selectedGroupIds: string[];
  onChange: (groupIds: string[]) => void;
  label?: string;
  excludeGroupIds?: string[];
  hideDescription?: boolean;
  readOnly?: boolean;
};

/** Shared multi-select of the available personalization GOGs, used across the bid group dimension modals. */
export function PersonalizationGroupsField(props: PersonalizationGroupsFieldProps) {
  const {
    dimensionResults,
    selectedGroupIds,
    onChange,
    label = "Personalization",
    hideDescription = false,
    excludeGroupIds = [],
    readOnly = false,
  } = props;

  // TODO: Remove this once the feature is ready to be exposed on prod.
  if (!showPBBv2Personalization) return null;

  // Group-based (personalization) results carry a `group` instead of a `type`.
  const groups = dimensionResults
    .filter((r) => r.kind === PotentialBidPlanDimensionKind.Personalization)
    .map((r) => r.group!)
    .filter((group) => !excludeGroupIds.includes(group.id));

  if (groups.isEmpty) return null;

  return (
    <div>
      {!hideDescription && !readOnly && (
        <div css={Css.mb1.$}>
          Select the personalization options to include as lines in your bid sheet as base configuration. Defining base
          vs add ons allows trades to price out whole house options and price add ons separately.
        </div>
      )}
      <MultiSelectField
        fullWidth
        readOnly={readOnly}
        label={label}
        options={groups}
        values={selectedGroupIds}
        onSelect={onChange}
        getOptionMenuLabel={getOptionMenuLabel}
      />
    </div>
  );
}

/** Show the plan name to tell apart options with the same name from different plans (e.g. ADU vs main house). */
function getOptionMenuLabel(group: ConfigureBidGroupsStep_PotentialBidPlanDimensionResultFragment["group"]) {
  if (!group?.readyPlan) return group?.name;
  return (
    <>
      {group.name}
      <Chip text={group.readyPlan.name} compact title={group.readyPlan.name} />
    </>
  );
}
